import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import { totalSubsImg } from "../../../../exports/Images";
import { selectToken } from "../../../auth/auth.selector";
import {
  fetchStaffTargetsData,
  fetchTMTAData2,
  fetchTargetAchievedData1,
  fetchTrainerRatingsData,
  // fetchTrainersMonthlyTagetData,
  fetchTrainersOccupancyData,
  fetchTrainersTotalMembersData,
} from "../../../../redux/reducers/apiSlice";
import IncentiveHistory from "../../../incentive-system/incentive-penalty/IncentiveHistory";
import AttendanceHistoryDetails from "../admin-level/AttendanceHistoryDetails";
import AttendanceHistory from "../AttendanceHistory";
import OccupencyDetails from "../../../components-react/OccupencyDetails";
import AssignedMembers from "../AssignedMembers";
import TEPLargeCard from "../../tepl-cards/common/TEPLargeCard";
import TargetAssign from "../admin-level/TargetAssign";

const TrainerDetailsCard = ({ sendableQPs }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);

  const {
    // loading,
    tmtaLoading2,
    tmtaData2,
    // trainersMonthlyTargetData,
    achievedTargetData1,
    trainerOccupancyData,
    trainerRatingsData,
    trainersTotalMembersData,
    staffTargets,
  } = useSelector((state) => state.api);

  const trainerIdRegex = /trainer_id=([^&]*)/;
  const trainerIdMatch = sendableQPs.match(trainerIdRegex);
  const trainerId = trainerIdMatch ? trainerIdMatch[1] : null;
  const modifiedQPs = sendableQPs.replace(
    /trainer_id=[^&]*/,
    `user_id=${trainerId}`
  );

  const [totalEarningsData, setTotalEarningsData] = useState(null);
  const initialSaleshistoryData = {
    incentiveHistoryData: {
      earnings: null,
      monthly: null,
      quaterly: null,
      half_yearly: null,
      yearly: null,
      earnings_renewals: null,
      monthlyRenewals: null,
      quaterlyRenewals: null,
      half_yearlyRenewals: null,
      yearlyRenewals: null,
    },
    salesHistoryModal: false,
    tabName: "trainers-info",
  };
  const [saleshistory, setSaleshistory] = useState(initialSaleshistoryData);
  const baseSalary = parseInt(totalEarningsData?.base_salary || 0);
  const totalRenewals = parseInt(totalEarningsData?.renewals || 0);
  const totalRewards = parseInt(totalEarningsData?.rewards || 0);
  const totalPenalty = parseInt(totalEarningsData?.penalty || 0);
  const [allTargetsData, setAllTargetsData] = useState("");
  const [targetAchievedData, setTargetAchievedData] = useState(0);
  const [allGymsTAData, setAllGymsTAData] = useState([]);
  const [allAttendanceData, setAllAttendanceData] = useState("");
  const {
    missed_checkins_percentage,
    total_checkins,
    late_checkins,
    totalOnTimeCheckins,
  } = allAttendanceData || {};
  const [allTrainerInfo, setAllTrainerInfo] = useState(null);
  const {
    occupancy_percentage,
    total_available_slots,
    total_booked_slots,
    total_no_of_slots,
  } = allTrainerInfo || {};
  const [trainerRatings, setTrainerRatings] = useState(null);
  const { rounded_average_rating } = trainerRatings || {};
  const [totalMembersData, setTotalmembersData] = useState("");
  const { total_pt, total_regular, total_addon } = totalMembersData || {};

  const iniCardValues = {
    filterType: "",
    cardData: [],
    pagination: [],
    isPage: 0,
  };
  const [cardValues, setCardValues] = useState(iniCardValues);
  const { filterType } = cardValues || {};
  const [cardModal, setCardModal] = useState(false);
  const [targetAssignModal, setTargetAssignModal] = useState(false);

  const onClickCard = (filterType) => {
    setCardModal(true);
    setCardValues((prevs) => ({ ...prevs, filterType }));
  };

  const onCloseModal = () => {
    setCardModal(false);
    setCardValues(iniCardValues);
  };

  useEffect(() => {
    if (modifiedQPs) {
      dispatch(
        fetchTMTAData2({
          queryParameters: modifiedQPs,
          token: token,
        })
      );
    }
  }, [modifiedQPs]);

  useEffect(() => {
    if (sendableQPs) {
      let updatedSendableQPs = sendableQPs.replace("trainer_id", "user_id");

      dispatch(
        fetchStaffTargetsData({
          queryParameters: updatedSendableQPs,
          token: token,
        })
      );
      // dispatch(
      //   fetchTrainersMonthlyTagetData({
      //     queryParameters: updatedSendableQPs,
      //     token: token,
      //   })
      // );

      dispatch(
        fetchTargetAchievedData1({
          queryParameters: sendableQPs,
          token: token,
        })
      );

      dispatch(
        fetchTrainersOccupancyData({
          queryParameters: sendableQPs,
          token: token,
        })
      );

      dispatch(
        fetchTrainerRatingsData({
          queryParameters: sendableQPs,
          token: token,
        })
      );

      dispatch(
        fetchTrainersTotalMembersData({
          queryParameters: sendableQPs,
          token: token,
        })
      );
    }
  }, [sendableQPs]);

  useEffect(() => {
    if (tmtaData2?.status && tmtaData2?.data) {
      const {
        earning_details,
        target_details,
        target_acheived,
        attendance_details,
      } = tmtaData2.data || {};
      const {
        earnings,
        monthly,
        quaterly,
        yearly,
        half_yearly,
        earnings_renewals,
        monthlyRenewals,
        quaterlyRenewals,
        half_yearlyRenewals,
        yearlyRenewals,
      } = target_details?.[0] || {};

      setTotalEarningsData(earning_details);
      setSaleshistory((prevSaleshistory) => ({
        ...prevSaleshistory,
        incentiveHistoryData: {
          earnings: earnings ?? null,
          monthly: monthly ?? null,
          quaterly: quaterly ?? null,
          half_yearly: half_yearly ?? null,
          yearly: yearly ?? null,
          earnings_renewals: earnings_renewals ?? null,
          monthlyRenewals: monthlyRenewals ?? null,
          quaterlyRenewals: quaterlyRenewals ?? null,
          half_yearlyRenewals: half_yearlyRenewals ?? null,
          yearlyRenewals: yearlyRenewals ?? null,
        },
      }));
      setTargetAchievedData(target_acheived);
      setAllAttendanceData(attendance_details);
    } else {
      setTotalEarningsData(null);
      setSaleshistory((prevSaleshistory) => ({
        ...prevSaleshistory,
        incentiveHistoryData: null,
      }));
      setTargetAchievedData(0);
      setAllAttendanceData("");
    }

    // if (tmtaData?.status && tmtaData.data?.target_details) {
    //   const {
    //     earnings,
    //     monthly,
    //     quaterly,
    //     yearly,
    //     half_yearly,
    //     earnings_renewals,
    //     monthlyRenewals,
    //     quaterlyRenewals,
    //     half_yearlyRenewals,
    //     yearlyRenewals,
    //   } = tmtaData.data.target_details?.[0] || {};

    //   setSaleshistory((prevSaleshistory) => ({
    //     ...prevSaleshistory,
    //     incentiveHistoryData: {
    //       earnings: earnings ?? null,
    //       monthly: monthly ?? null,
    //       quaterly: quaterly ?? null,
    //       half_yearly: half_yearly ?? null,
    //       yearly: yearly ?? null,
    //       earnings_renewals: earnings_renewals ?? null,
    //       monthlyRenewals: monthlyRenewals ?? null,
    //       quaterlyRenewals: quaterlyRenewals ?? null,
    //       half_yearlyRenewals: half_yearlyRenewals ?? null,
    //       yearlyRenewals: yearlyRenewals ?? null,
    //     },
    //   }));
    // } else {
    //   setSaleshistory((prevSaleshistory) => ({
    //     ...prevSaleshistory,
    //     incentiveHistoryData: null,
    //   }));
    // }

    // if (tmtaData?.status && tmtaData?.data?.target_acheived) {
    //   setTargetAchievedData(tmtaData?.data?.target_acheived);
    // } else {
    //   setTargetAchievedData(0);
    // }

    // if (tmtaData?.status && tmtaData?.data?.attendance_details) {
    //   setAllAttendanceData(tmtaData.data.attendance_details);
    // } else {
    //   setAllAttendanceData("");
    // }
  }, [tmtaData2]);

  useEffect(() => {
    if (staffTargets?.status && staffTargets?.data) {
      setAllTargetsData(staffTargets.data?.[0]);
    } else {
      setAllTargetsData("");
    }
  }, [staffTargets]);

  useEffect(() => {
    if (achievedTargetData1?.status && achievedTargetData1?.data) {
      setAllGymsTAData(achievedTargetData1.data);
    } else {
      setAllGymsTAData([]);
    }
  }, [achievedTargetData1]);

  useEffect(() => {
    if (trainerOccupancyData?.status && trainerOccupancyData?.data) {
      setAllTrainerInfo(trainerOccupancyData.data);
    } else {
      setAllTrainerInfo(null);
    }
  }, [trainerOccupancyData]);

  useEffect(() => {
    if (trainerRatingsData?.status && trainerRatingsData?.data) {
      setTrainerRatings(trainerRatingsData.data?.[0]);
    } else {
      setTrainerRatings(null);
    }
  }, [trainerRatingsData]);

  useEffect(() => {
    if (trainersTotalMembersData?.status && trainersTotalMembersData?.data) {
      setTotalmembersData(trainersTotalMembersData.data?.[0]);
    } else {
      setTotalmembersData("");
    }
  }, [trainersTotalMembersData]);

  return (
    <>
      <Modal
        isOpen={cardModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            filterType === "total_earnings"
              ? "incentiveHostoryModalContainer"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${
              filterType === "total_earnings"
                ? "Sales History"
                : filterType === "occupancy"
                ? "Trainer Occupancy"
                : ""
            }`}
            onClose={onCloseModal}
          />

          <>
            {filterType === "total_earnings" ? (
              <IncentiveHistory rowData={saleshistory} />
            ) : filterType === "monthly_target" ? (
              <AttendanceHistoryDetails
                clickedCard={"targets"}
                gymsData={allGymsTAData}
              />
            ) : filterType === "attendance" ? (
              <AttendanceHistory
                onClose={onCloseModal}
                clickedCard={"attendance"}
                queryParametersForAll={sendableQPs}
              />
            ) : filterType === "occupancy" ? (
              <OccupencyDetails queryParametersForAll={sendableQPs} />
            ) : filterType === "total_members" ? (
              <AssignedMembers sendableQPs={sendableQPs} />
            ) : null}
          </>
        </div>
      </Modal>

      <Modal
        isOpen={targetAssignModal}
        onRequestClose={() => setTargetAssignModal(false)}
        contentLabel="Target Assign Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer cloud-bg-k borderRadiusTen">
          <ModalHeadAndClose
            title="Target Assign"
            onClose={() => setTargetAssignModal(false)}
          />

          <TargetAssign
            // previousFilters={tdFilters}
            prevData={allTargetsData}
            queryParams={modifiedQPs}
            closeModal={() => setTargetAssignModal(false)}
            callFunction={() =>
              dispatch(
                fetchStaffTargetsData({
                  queryParameters: modifiedQPs,
                  token: token,
                })
              )
            }
          />
        </div>
      </Modal>

      <div className="cards-container cards-grid-container threeGridSystem card-y-large">
        <TEPLargeCard
          cardName={"trainer-details"}
          filterType={"total_earnings"}
          cardImg={totalSubsImg}
          baseSalary={baseSalary || 0}
          rewards={totalRewards || 0}
          renewals={totalRenewals || 0}
          penalty={totalPenalty || 0}
          cardTitle={"Total Earnings"}
          onClickCard={onClickCard}
          isLoading={tmtaLoading2}
        />

        {/* <TEPLargeCard
          cardName={"trainer-details"}
          filterType={"monthly_target"}
          cardImg={totalSubsImg}
          targetValues={allTargetsData}
          targetAssigned={allTargetsData?.target_value || 0}
          targetAchieved={targetAchievedData || 0}
          cardTitle={"Monthly Target"}
          onClickCard={() => setTargetAssignModal(true)}
        /> */}

        <TEPLargeCard
          cardName={"trainer-details"}
          filterType={"attendance"}
          cardImg={totalSubsImg}
          missedCheckinsPer={
            missed_checkins_percentage
              ? parseFloat(missed_checkins_percentage || 0).toFixed()
              : 0
          }
          totalCheckins={total_checkins || 0}
          lateCheckins={late_checkins || 0}
          totalOnTimeCheckins={totalOnTimeCheckins || 0}
          cardTitle={"Attendance"}
          onClickCard={onClickCard}
        />

        <TEPLargeCard
          cardName={"trainer-details"}
          filterType={"occupancy"}
          cardImg={totalSubsImg}
          occupationPer={
            occupancy_percentage
              ? parseFloat(occupancy_percentage).toFixed()
              : 0
          }
          totalSlots={
            total_no_of_slots ? parseFloat(total_no_of_slots).toFixed() : 0
          }
          availSlots={
            total_available_slots
              ? parseFloat(total_available_slots).toFixed()
              : 0
          }
          bookedSlots={
            total_booked_slots ? parseFloat(total_booked_slots).toFixed() : 0
          }
          cardTitle={"Occupancy"}
          onClickCard={onClickCard}
        />

        <TEPLargeCard
          cardName={"trainer-details"}
          filterType={"ratings"}
          cardImg={totalSubsImg}
          rating={rounded_average_rating || 0}
          cardTitle={"Ratings"}
          onClickCard={onClickCard}
        />

        <TEPLargeCard
          cardName={"trainer-details"}
          filterType={"total_members"}
          cardImg={totalSubsImg}
          pts={total_pt || 0}
          regulars={total_regular || 0}
          // addons={total_addon || 0}
          totalMembersData={totalMembersData}
          // goalFocus={total_goal_focus || 0}
          cardTitle={"Total Members Added This Month"}
          onClickCard={onClickCard}
        />
      </div>
    </>
  );
};

export default TrainerDetailsCard;
